import get from 'lodash/get'
import ApiProcessor from '../../processors/api-processor'
import Status from '../../components/status/status.vue'
import store from '~/state/store'

const INACTIVE_CELL_STYLE = {
  opacity: 0.4,
}

function cellStyle(status) {
  return status ? {} : INACTIVE_CELL_STYLE
}

const TABLE_FILTERS = [{
  attribute: 'active',
  label: 'Status',
  type: 'boolean',
  icon: 'el-icon-circle-check',
  booleanValues: {
    is_true: {
      label: 'Active',
      value: true,
    },
    is_false: {
      label: 'Inactive',
      value: false,
    },
  },
}, {
  attribute: 'name',
  label: 'Retailer Name',
  type: 'string',
  icon: 'el-icon-document',
}, {
  attribute: 'category.name',
  label: 'Categories',
  type: 'string',
  icon: 'el-icon-document',
}, {
  attribute: 'offersCount',
  label: 'Number of Offers',
  type: 'numeric',
  icon: 'el-icon-document',
}, {
  attribute: 'createdAt',
  label: 'Date Created',
  type: 'date',
  icon: 'el-icon-time',
}]

const TABLE_COLUMNS = [{
  name: 'active',
  label: 'Status',
  icon: 'el-icon-circle-check',
  width: 200,
  component: (_, __, { row }) => ({
    is: Status,
    props: {
      status: row.active,
      inactiveStyle: INACTIVE_CELL_STYLE,
    },
  }),
}, {
  name: 'logo',
  label: 'Retailer Logo',
  icon: 'el-icon-document',
  width: 140,
  sortable: false,
  component: (_, __, { row }) => ({
    is: 'cell-logo',
    props: {
      showDefaultLogo: true,
      rounded: true,
      inactive: !row.active,
    },
  }),
  format(value) {
    return value ? `${value}//-/preview/40x40/-/quality/best/` : ''
  },
}, {
  name: 'name',
  label: 'Retailer Name',
  icon: 'el-icon-document',
  width: 300,
  component: {
    props: {
      styleObj(_, { active }) {
        return cellStyle(active)
      },
    },
  },
}, {
  name: 'category.name',
  label: 'Categories',
  type: 'string',
  icon: 'el-icon-document',
  width: 200,
  component: {
    props: {
      styleObj(_, { active }) {
        return cellStyle(active)
      },
    },
  },
}, {
  name: 'providerId',
  label: 'Provider',
  icon: 'el-icon-document',
  format: (val, row) => {
    const provider = store.getters['providers/provider'](val)
    return get(provider, 'name', '')
  },
}, {
  name: 'offersCount',
  label: 'Number of Offers',
  icon: 'el-icon-document',
  width: 200,
  component: {
    props: {
      styleObj(_, { active }) {
        return cellStyle(active)
      },
    },
  },
}, {
  name: 'createdAt',
  label: 'Date Created',
  icon: 'el-icon-time',
  format: {
    name: 'date',
    params: ['DD/MM/YYYY'],
  },
  component: {
    props: {
      styleObj(_, { active }) {
        return cellStyle(active)
      },
    },
  },
  width: 200,
}]

export default component => {
  return {
    processor: new ApiProcessor({
      component,
      path: 'retailers',
      initialDataQuery: { pageSize: 25 },
    }),
    filters: TABLE_FILTERS,
    columns: TABLE_COLUMNS,
    tableName: 'retailers',
  }
}
